import { useCallback } from 'react';
import { getAnalytics } from 'src/lib/analytics/analytics.service';
import { tGenericObject } from 'src/providers/SocketsProvider/Sockets.types';
import { useUserContext } from 'src/providers/UserProvider/User.context';
import { useWorkspaceContext } from 'src/providers/WorkspaceProvider/Workspace.context';

export const useAnalytics = () => {
  const { currentUserRole } = useUserContext();
  const { currentWorkspaceId } = useWorkspaceContext();

  const trackEvent = useCallback(
    (name: string, payload: tGenericObject = {}) => {
      if (!currentWorkspaceId) return;
      getAnalytics().track(name, {
        workspace_id: currentWorkspaceId,
        user_role: currentUserRole,
        ...payload,
      });
    },
    [currentWorkspaceId, currentUserRole],
  );

  return { trackEvent };
};
